import { ReactComponent as LogoSVG } from "./logo-rounded-pixel.svg";

export const Logo = () => {
  return (
    <>
      <LogoSVG />
    </>
  );
};
